import React, { Component } from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';
import { Link } from 'react-router-dom';
import Dsm from './Dsm';
import DialogStateGraph from './DialogStateGraph';

import $ from 'jquery';

class DsmSubTabsPage extends Component {

    componentDidMount() {
        (function () {
            var currentPath = window.location.href;
            var path = window.origin + "/platform/projectmgmt/nlutab/dsm";
            var path1 = window.origin + "/platform/projectmgmt/nlutab/dsm/";
            if (currentPath === path || currentPath === path1) {
                $("#dialog-state-transition-tab").addClass('active');

            } else if (currentPath.includes('/projectmgmt/nlutab/dsm/dsm-graphs')) {
                $("#dialog-state-graph-tab").addClass('active');
            } $("#dialog-state-transition-tab,#dialog-state-graph-tab")
                .on("click", function () {
                    $("#dialog-state-transition-tab,#dialog-state-graph-tab")
                        .removeClass('active');
                    localStorage.setItem("last-used-team-settings-sub-tab", $(this)[0].id);
                    $(this).addClass('active')
                })
        })();
    }
    render() {
        return (

            <div id="tabPage" >
                <div className="content" style={{ backgroundColor: "#F9F9FB" }}>

                    <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
                    <title> Dheeyantra | Clusters Details</title>
                    {/* Font Awesome Icons */}
                    <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
                    {/* IonIcons */}
                    <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
                    <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
                    {/* Theme style */}
                    <link rel="stylesheet" href="assets/css/adminlte.css" />
                    <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
                    <link rel="stylesheet" href="assets/css/custom-style.css" />
                    <link rel="stylesheet" href="assets/css/styles.css" />
                    <link rel="stylesheet" href="./assets/css/toggleButton.css" />
                    <link rel="stylesheet" href="assets/css/custom-style.css" />

                    <div className="container-fluid" style={{ marginLeft: '0px' }} >
                        {/* Nav tabs */}
                        <div className="tab-class">
                            <ul className="nav nav-tabs border-bottom navCluster" >
                                <Link className="nav-item" data-toggle="tab" to="/projectmgmt/nlutab/dsm" style={{ textDecoration: 'none' }}>
                                    <li className="nav-link" id="dialog-state-transition-tab">
                                        Dialog State Transitions
                                    </li>
                                </Link>
                                <Link className="nav-item" data-toggle="tab" to="/projectmgmt/nlutab/dsm/dsm-graphs" style={{ textDecoration: 'none' }}>
                                    <li className="nav-link" id="dialog-state-graph-tab">
                                        Dialog Work Flow
                                    </li>
                                </Link>

                            </ul>
                        </div>
                    </div>
                </div>
                <Switch>
                    <Route path="/projectmgmt/nlutab/dsm/dsm-graphs" component={DialogStateGraph}></Route>
                    <Route path="/projectmgmt/nlutab/dsm" component={Dsm}></Route>
                </Switch>
            </div>

        );
    }
}
export default DsmSubTabsPage;


// WEBPACK FOOTER //
// ./src/projectmgmt/nlu/transition/DsmSubTabsPage.js